"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupTags = void 0;
var PopupTags;
(function (PopupTags) {
    PopupTags["Desktop"] = "desktop";
    PopupTags["Mobile"] = "mobile";
    PopupTags["Allpages"] = "allpages";
    PopupTags["Live"] = "live";
    PopupTags["Prematch"] = "prematch";
    PopupTags["Casino"] = "casino";
    PopupTags["Bonuses"] = "bonuses";
    PopupTags["Livecasino"] = "livecasino";
    PopupTags["Slots"] = "slots";
})(PopupTags || (exports.PopupTags = PopupTags = {}));
//# sourceMappingURL=popup.js.map